// Card.js
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Card as MuiCard, CardContent, Typography, CardHeader, Box, Grid, Divider } from '@mui/material';
import { formatarDataHora, numberWithCommas, identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado } from '../../utils';
import ImpressaoIcon from '../../assets/img/impressora.svg';
import CloseIcon from '../../assets/img/close.svg';
import LogoNafil from '../../assets/img/NAFIL_logo.svg';
import LogoN from '../../assets/img/NAFIL_logoCurto.svg';
import Button from '@mui/material/Button';
import { MyContext } from '../../context/MyContext';
import Avatar from '@mui/material/Avatar';
import { ReactToPrint, useReactToPrint } from 'react-to-print';
import QRCodeStyling from "qr-code-styling";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../services/api';
import { toPng } from 'html-to-image'; // Biblioteca para converter o QRCode em PNG
import { AirlineSeatReclineExtraOutlined } from '@mui/icons-material';
import InputMask from 'react-input-mask';
import Modal from '@mui/material/Modal';
//import { formatarDataHora } from './../../utils';

const Card = (props) => {
    const { showModalMeuPagamentoFaturado, setShowModalMeuPagamentoFaturado } = useContext(MyContext);
    const [urlQRCode, setUrlQRCode] = useState("");
    const [processoNumero, setProcessoNumero] = useState("");
    const [processoData, setProcessoData] = useState("");
    const [colunas, setColunas] = useState([[], [], []]);  // Array para armazenar as colunas
    const [qrCodeComponente, setQrCodeComponente] = useState(null);
    const qrCodeInstance = useRef(null);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [dadosConteudoParaImpressao, setDadosConteudoParaImpressao] = useState([]);
    const [satonImpressaoProcessoId, setSatonImpressaoProcessoId] = useState(0);
    const [satonImpressaoProcessoIdLoja, setSatonImpressaoProcessoIdLoja] = useState(0);
    const [satonOriginal, setSatonOriginal] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    // const [linkPagamentoFaturado,SetLinkPagamentoFaturado] = useState("");
    const { showModalMeuPagamentoFaturadoReciboDePagamento, setShowModalMeuPagamentoFaturadoReciboDePagamento } = useContext(MyContext);
    // const [showModalMeuTelefone, setShowModalMeuTelefone] = useState(false);
    const componentRef = useRef();
    const [criarLinkPagamento, setCriarLinkPagamento] = useState(false);
    const [linkPagamento, setLinkPagamento] = useState("");
    const [botaoClicado, setBotaoClicado] = useState("");
    const [modelo, setModelo] = useState(0);
    const isLocalhost = window.location.hostname === 'localhost';
    const baseUrl = isLocalhost ? 'http://localhost:3000' : 'https://whats.nafil.com.br';
    let vendaAtual = null;  // Variável para rastrear a venda atual
    let vendasAgrupadas = [];  // Armazena as vendas agrupadas por id_venda
    const linhasPorColuna = 8; // Definindo limite de linhas por coluna
    let colunaAtual = -1;  // Coluna atual (0 = esquerda, 1 = centro, 2 = direita) -1 Porque Será Somado 1 ao inciar
    let linhasPreenchidas = 0;  // Contador de linhas preenchidas
    let itensNaPagina = 0;  //


    console.log("MIGAO ", props);

    let limiteLinhasPorPagina = Math.ceil(props.props.satonParcial.length / 3);  // Notas Inteiras ou Contador de linhas preenchidas
    let vendasAgrupadasLinhasPorColuna = [];  // Armazena as vendas agrupadas por id_venda
    const [showModalMeuTelefone, setShowModalMeuTelefone] = useState(false);
    const qrCodeRef = useRef(null);
    const dataToPrintRef = useRef();
    let _temPIXpendente = null;

    useEffect(() => {
        qrCodeInstance.current = new QRCodeStyling({
            width: 200,
            height: 200,
            data: urlQRCode,
            image:
                LogoN,
            dotsOptions: {
                color: "#000000",
                type: "rounded"
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 5
            }
        });

        qrCodeInstance.current.append(qrCodeRef.current);
        montarImpressao();
    }, []);

    const handlePrint = useReactToPrint({
        content: () => dataToPrintRef.current
    });


    useEffect(() => {

        console.log("BOTAO1111", botaoClicado);

        const handleCriarLinkPagamento = async () => {
            let usuario_logado = identificacaoUsuarioLogado();
            let _userId = usuario_logado.split('_')[0];
            let _userIdloja = usuario_logado.split('_')[1];
            let _nomeFullRazaoSocialLogado = identificacaoRazaoSocialUsuarioLogado();

            const dados = JSON.parse(`{"plainText":"idCliente=${props.props.fatorParcial.id_cliente}/idClienteLoja=${props.props.fatorParcial.id_loja_cliente}/idPreVenda=0/idPreVendaLoja=0/idProcesso=${props.props.fatorParcial.ids_fator}/idProcessoLoja=${props.props.fatorParcial.ids_loja_fator}"}`);

            try {
                let APIdados = await api.post(`Saton/CriarLinkPagamentoFaturado60minutos`, dados)
                    .then((response) => {
                        // console.log("LIXO => ", response.data);                    
                        // SetLinkPagamentoFaturado(response.data);    
                        // setDadosConteudoParaImpressao(response.data);
                        // setShowModalMeuPagamentoFaturado(true);
                        if (response.data != null) {
                            setLinkPagamento(`${baseUrl}/compartilhado?pagamento=${response.data.encryptedText}`);
                            console.log("Rog 10", `${baseUrl}/compartilhado?pagamento=${response.data.encryptedText}`);
                            // handleEnviarMensagemWhatsApp(response.data);  // LINK DE PAGAMENTO                                
                        }
                    })
                    .catch((erro) => {
                        // console.log("SEM DEUS => ", erro);    
                        // setDadosConteudoParaImpressao(null);
                        // SetLinkPagamentoFaturado(null);
                        toastMensagemError("Falhou: " + erro.message)
                        return null;
                    });
            } catch (e) {
                setDadosConteudoParaImpressao(null);
                toastMensagemError("Falha Geral: " + e.message)
                return null;
            };
            // };            
        };

        handleCriarLinkPagamento();

        console.log("BOTAO ", botaoClicado, linkPagamento);
        // Compartilhar
        // Copiar Link Pagamento

        if (linkPagamento != null && linkPagamento != "" && botaoClicado == "Copiar Link Pagamento") {

            console.log("ROG 40", linkPagamento);
            navigator.clipboard.writeText(linkPagamento);
            linkPagamentoCopiadoSucesso();
        }
        if (linkPagamento != null && linkPagamento != "" && botaoClicado == "Compartilhar") {
            //     navigator.clipboard.writeText(linkPagamento);

            console.log("ROG 23", linkPagamento);

            handleEnviarMensagemWhatsApp(linkPagamento);  // LINK DE PAGAMENTO                                
        }
    }, [criarLinkPagamento]);


    useEffect(() => {
        if (linkPagamento == null || linkPagamento.length == 0) {
            setCriarLinkPagamento();
        }

        if (modelo == 1) {
            if (window.navigator.maxTouchPoints > 0) // DECIDE SE É: 0 = DESKTOP --- 1 = CELULARES MOBILES 
            {
                // ENVIA PELO APP
                if (navigator.share) {
                    navigator
                        .share({
                            title: 'NAFIL Efetuar Pagamento',
                            text: 'Olá! Acesse o link abaixo para realizar o pagamento:',
                            url: linkPagamento, // Coloque aqui o link de pagamento
                        })
                        .then(() => console.log('Compartilhamento concluído com sucesso'))
                        .catch((error) => console.error('Erro ao compartilhar:', error));
                } else {
                    alert('Compartilhamento Não Suportado Neste Dispositivo.');
                }
            }
            else { // DESKTOP

                if (showModalMeuTelefone) {
                    setShowModalMeuTelefone(false);
                    return;
                }
                else {
                    setShowModalMeuTelefone(true);
                }
                console.log("LINKOUUUU D", showModalMeuTelefone);
                // if (showModalMeuTelefone) {
                //     toastMensagemError("Clique no Botão 'Enviar Mensagem'!")
                //    return;
                // }
                // else {
                //     setShowModalMeuTelefone(true);
                // }
            }
        }
        else if (modelo == 2) {
            navigator.clipboard.writeText(linkPagamento);
            linkPagamentoCopiadoSucesso();
        }
        else if (modelo == 3) { // Clicou no Botão 'ENVIAR MENSAGEM' Utilizado na Versão 
            const numeroDestinatario = phoneNumber.replace(/\D/g, '');
            const textoMensagem = encodeURIComponent("Olá! Acesse o link abaixo para realizar o pagamento:");
            const linkMensagem = linkPagamento.replaceAll(" ", "+"); // Substitua pelo seu link          
            console.log("ROG 34", linkMensagem);
            const urlWhatsApp = `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}%0A${linkMensagem}`;
            window.open(urlWhatsApp, '_blank');
        }
    }, [modelo])

    const toastMarcarItensParaImpressao = () => toast.error("Selecione Algum Item Para Impressão!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const functionCopyToClipboard = async (_caminho) => {
        if (_caminho != null && _caminho.length > 0) {
            setUrlQRCode(_caminho);
            navigator.clipboard.writeText(_caminho);
            pixCopiadoSucesso("PIX Copiado com Sucesso G");
        }
    }

    const pixCopiadoSucesso = (nome) => toast.success("PIX Copiado com Sucesso H",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 1500 });

    const linkPagamentoCopiadoSucesso = (nome) => toast.success("Link de Pagamento Copiado com Sucesso",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 1500 });

    const styleTelefone = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
    };

    const handleCompartilharLinkPagamento = async () => {
        setBotaoClicado("Compartilhar");

        if (linkPagamento == null || linkPagamento == "") {
            console.log("ROG 36", linkPagamento);
            setCriarLinkPagamento(true);
            // } else {
            //     handleEnviarMensagemWhatsApp(linkPagamento);  // LINK DE PAGAMENTO                                
        }
        else {

            console.log("ROG 39", linkPagamento);
            handleEnviarWhatsAppWeb();
        }
    };

    const handleLinkPagamento = async (data) => {

        setBotaoClicado("Copiar Link Pagamento");


        if (linkPagamento == "") {

            console.log("ROG 22 ", linkPagamento);
            setCriarLinkPagamento(true);

            //            let _retornoLink = await handleCriarLinkPagamento();

            // console.log("LIXO ", linkPagamento);

            // if (linkPagamento != null && linkPagamento != ""){
            //     navigator.clipboard.writeText(linkPagamento);
            // }
        }
        // else {
        //     navigator.clipboard.writeText(data.encryptedText);
        // }
    };

    const handleInputChange = (event) => {
        setPhoneNumber(event.target.value);
    };

    console.log("LINKOUUUU JOAO", showModalMeuTelefone);


    const handleSendMensagemWhatsApp = (modelo) => {
        if (modelo == 1) { // BOTÃO COMPARTILHAR
            if (window.navigator.maxTouchPoints > 0) // DECIDE SE É: 0 = DESKTOP --- 1 = CELULARES MOBILES 
            {
                // ENVIA PELO APP
                if (navigator.share) {

                    console.log("LINKOUUUU G", linkPagamento);

                    navigator
                        .share({
                            title: 'NAFIL Efetuar Pagamento',
                            text: 'Olá! Acesse o link abaixo para realizar o pagamento:',
                            url: linkPagamento, // Coloque aqui o link de pagamento
                        })
                        .then(() => console.log('Compartilhamento concluído com sucesso'))
                        .catch((error) => console.error('Erro ao compartilhar:', error));
                } else {
                    alert('Compartilhamento Não Suportado Neste Dispositivo.');
                }
                console.log("LINKOUUUU C", modelo);
            }
            else { // DESKTOP

                console.log("LINKOUUUU D", showModalMeuTelefone);
                // if (showModalMeuTelefone) {
                //     toastMensagemError("Clique no Botão 'Enviar Mensagem'!")
                //    return;
                // }
                // else {
                //     setShowModalMeuTelefone(true);
                // }
            }

        }



        console.log("LINKOUUUU A", modelo, showModalMeuTelefone);

        if (modelo == 1 && showModalMeuTelefone == false) {

            setShowModalMeuTelefone(true);
            // handleMudarEstadoModelo(true);

            console.log("LINKOUUUU B", modelo, showModalMeuTelefone);

            return;
        }



        console.log("LINKOUUUU E", linkPagamento);


        switch (modelo) {
            case 1: // WhatsApp APP

                console.log("LINKOUUUU F", linkPagamento);

                setShowModalMeuTelefone(false);
                // handleMudarEstadoModelo(false);

                break;

            case 2:  // WhatsAPP WEB

                console.log("LINKOUUUU H", linkPagamento);

                const numeroDestinatario = phoneNumber.replace(/\D/g, '');
                const textoMensagem = encodeURIComponent("Olá! Acesse o link abaixo para realizar o pagamento:");
                const linkMensagem = linkPagamento.replaceAll(" ", "+"); // Substitua pelo seu link          
                console.log("ROG 34", linkMensagem);
                const urlWhatsApp = `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}%0A${linkMensagem}`;
                window.open(urlWhatsApp, '_blank');
                break;
            default:
            // code block
        }
    };

    const handleEnviarWhatsAppWeb = () => {
        // Removendo caracteres especiais da máscara para obter apenas números


        console.log("ROG 33", linkPagamento);

        const numeroDestinatario = phoneNumber.replace(/\D/g, '');
        const textoMensagem = encodeURIComponent("Olá! Acesse o link abaixo para realizar o pagamento:");
        const linkMensagem = linkPagamento.replaceAll(" ", "+"); // Substitua pelo seu link          

        console.log("ROG 34", linkMensagem);

        const urlWhatsApp = `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}%0A${linkMensagem}`;
        window.open(urlWhatsApp, '_blank');
    };

    const handleEnviarMensagemWhatsApp = (parametros) => {
        // const isLocalhost = window.location.hostname === 'localhost';
        // const baseUrl = isLocalhost ? 'http://localhost:3000' : 'https://whats.nafil.com.br';
        //VOLTAR setLinkPagamento(`${baseUrl}/compartilhado?pagamento=${parametros.encryptedText}`);

        console.log("LINKOUUUABC ", linkPagamento);

        if (window.navigator.maxTouchPoints > 0) // 0 = DESKTOP --- 1 = CELULARES MOBILES 
        {
            console.log("LINKOUUUU ", linkPagamento);

            if (navigator.share) {
                navigator
                    .share({
                        title: 'NAFIL Efetuar Pagamento',
                        text: 'Olá! Acesse o link abaixo para realizar o pagamento:',
                        url: linkPagamento, // Coloque aqui o link de pagamento
                    })
                    .then(() => console.log('Compartilhamento concluído com sucesso'))
                    .catch((error) => console.error('Erro ao compartilhar:', error));
            } else {
                console.log("LINKOUUUXABC ", linkPagamento);
                // console.log("WPPPPA 2");
                // try {
                //    setShowModalMeuTelefone(true);
                // WhatsAppShare(linkPagamento);
                // // alert('Compartilhamento Não Suportado Neste Dispositivo.');
                // // if (window.innerWidth >= 1024) { // Verifica se é um desktop com base na largura da janela
                // const numeroDestinatario = "5524988027944"; // Número no formato internacional
                // const textoMensagem = encodeURIComponent("Olá! Acesse o link abaixo para realizar o pagamento:");
                // const linkMensagem = linkPagamento; // Substitua pelo seu link
                // const urlWhatsApp = `https://web.whatsapp.com/send?phone=${numeroDestinatario}&text=${textoMensagem}%0A${linkMensagem}`;
                // window.open(urlWhatsApp, '_blank'); // Abre o WhatsApp Web em uma nova aba
                // }
                // } catch (errorWeb) {
                //     console.log("WPPPPA 3", errorWeb);
                //     alert('Compartilhamento Disponível Apenas em Dispositivos Móveis ou WhatsApp Web!');
                // }
            }
        }
        else {
            console.log("WPPPPA 3 ABC");
            //  setShowModalMeuTelefone(true);
        }
    };

    // const handleCompartilharLinkPagamento = async () => {
    //     if (selectionModel == null || selectionModel.length == 0) {
    //         toastMarcarItensParaImpressao();
    //     }
    //     let _itensSelecionados = [];

    //     selectionModel.forEach((item) => {
    //         if (item.substring(0, 1) == "-") {
    //             _itensSelecionados.push(item.substring(1, item.length));
    //         }
    //         else {
    //             _itensSelecionados.push(item);
    //         }
    //     });
    //     _itensSelecionados = satonOriginal.filter((item) => {
    //         return _itensSelecionados.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
    //     });
    //     let _processosSelecionados = [];
    //     _itensSelecionados.forEach((item) => {
    //         if (item.processo != null) { // } && item.processo > 0) {
    //             let _registroProcesso = item.processo + "-" + item.processo_loja;
    //             if (_processosSelecionados.indexOf(_registroProcesso) === -1) {
    //                 _processosSelecionados.push(_registroProcesso);
    //             }
    //         }
    //     });
    //     let usuario_logado = identificacaoUsuarioLogado();
    //     let _userId = usuario_logado.split('_')[0];
    //     let _userIdloja = usuario_logado.split('_')[1];
    //     //let _nomeFullRazaoSocialLogado = identificacaoRazaoSocialUsuarioLogado();
    //     for (const itemSelect of _processosSelecionados) {
    //         setSatonImpressaoProcessoId(itemSelect.split('-')[0]);
    //         setSatonImpressaoProcessoIdLoja(itemSelect.split('-')[1]);
    //         let _processoId = itemSelect.split('-')[0]
    //         let _processoIdLoja = itemSelect.split('-')[1]

    //         const dados = JSON.parse(`{"plainText":"idCliente=${_userId}/idClienteLoja=${_userIdloja}/idPreVenda=0/idPreVendaLoja=0/idProcesso=${_processoId}/idProcessoLoja=${_processoIdLoja}"}`);

    //         console.log("VACACAC ", dados);

    //         try {
    //             let APIdados = await api.post(`Saton/CriarLinkPagamentoFaturado60minutos`, dados)
    //                 .then((response) => {

    //                     console.log("DEUS => ", response.data);

    //                     // setDadosConteudoParaImpressao(response.data);
    //                     // setShowModalMeuPagamentoFaturado(true);
    //                 })
    //                 .catch((erro) => {

    //                     console.log("SEM DEUS => ", erro);

    //                     setDadosConteudoParaImpressao(null);
    //                     toastMensagemError("Falhou: " + erro.message)
    //                 });
    //         } catch (e) {
    //             setDadosConteudoParaImpressao(null);
    //             toastMensagemError("Falha Geral: " + e.message)
    //             return null;
    //         };
    //     };
    // };

    const mostrar_meios_pagamentos = (especie) => {
        let _objetosRetorno = "";

        return especie.map((xpg, index) => {
            if (xpg.nband == 1) {  // DINHEIRO
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{verificar_situacao_pagamento(xpg)}</strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else if (xpg.nband == 2) {  // CHEQUE
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong></strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else if (xpg.nband == 3) {  // CARTÃO DE CRÉDITO
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{(xpg.cartao != null && xpg.cartao != "" && xpg.finalizado == 1 ? xpg.bandeira + " x " + xpg.vezes + " " + (xpg.cartao == null ? "" : "FINAL " + xpg.cartao.trim().substring(xpg.cartao.trim().length - 4)) : "x " + xpg.vezes)}</strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else if (xpg.nband == 4) {  // CARTÃO DE DÉBITO
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{(xpg.cartao != null && xpg.cartao != "" && xpg.finalizado == 1 ? xpg.bandeira + " x " + xpg.vezes + " " + (xpg.cartao == null ? "" : "FINAL " + xpg.cartao.trim().substring(xpg.cartao.trim().length - 4)) : "x " + xpg.vezes)}</strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else if (xpg.nband == 5) {  // CRÉDITO LOJA
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{(xpg.cartao != null && xpg.cartao != "" && xpg.finalizado == 1 ? xpg.cartao : "")}</strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            // else if (xpg.nband == 6) {  // FATURADO
            //     return (
            //         <React.Fragment key={index}>
            //             <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
            //             <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>AGUARDANDO PAGAMENTO</strong></Grid>
            //             <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
            //         </React.Fragment>)
            // }
            else if (xpg.nband == 15) {  // BOLETO BANCÁRIO
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong></strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else if (xpg.nband == 16) {  // DEPÓSITO BANCÁRIO
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'8px'}><strong></strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'8px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else if (xpg.nband == 17 && xpg.pix_recebido == null) {  // PIX AGUARDANDO 
                setUrlQRCode(xpg.pix_copia_cola);
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'6px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'6px'}><strong>{verificar_situacao_pagamento(xpg)}</strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'6px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>

                        <Grid item xs={12} fontSize={'9px'} textAlign={'center'} paddingRight={'6px'}>
                            <p>{xpg.pix_copia_cola}</p>
                        </Grid>

                        <Grid item xs={12} fontSize={'11px'} textAlign={'right'} paddingRight={'6px'}>
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{ marginBottom: '20px' }}
                            >
                                <Grid item xs={12}>
                                    <Box>
                                        <div ref={qrCodeRef} />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box>
                                        <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }} onClick={() => functionCopyToClipboard(xpg.pix_copia_cola)}>Copia e Cola</Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box>
                                        {/* <Button variant="contained" onClick={() => handleCompartilharLinkPagamento()} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button> */}
                                        {/* <Button variant="contained" onClick={() => handleSendMensagemWhatsApp(1)} disabled={showModalMeuTelefone} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button> */}
                                        <Button variant="contained" onClick={() => setModelo(1)} disabled={showModalMeuTelefone} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button>
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <Box>
                                        {/* <Button variant="contained" onClick={() => handleLinkPagamento()} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Copiar Link Pagamento</Button> */}
                                        {/* <Button variant="contained" onClick={() => handleSendMensagemWhatsApp(2)} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Copiar Link Pagamento</Button> */}
                                        <Button variant="contained" onClick={() => setModelo(2)} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Copiar Link Pagamento</Button>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Grid>

                    </React.Fragment>)
            }
            else if (xpg.nband == 17 && xpg.pix_recebido != null) {  // PIX AGUARDANDO PAGAMENTO
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'6px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'6px'}><strong>{formatarDataHora(xpg.pix_recebido, 4)}</strong></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'6px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
            else // NENHUMA DA OPÇÕES ACIMA 
            {
                return (
                    <React.Fragment key={index}>
                        <Grid item xs={4} fontSize={'11px'} textAlign={'left'} paddingLeft={'6px'}><strong>{xpg.tipo}</strong></Grid>
                        <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'} paddingLeft={'6px'}></Grid>
                        <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'} paddingRight={'6px'}><strong>{numberWithCommas(xpg.valor)}</strong></Grid>
                    </React.Fragment>)
            }
        })
    }

    const verificar_situacao_pagamento = (especie) => {
        switch (especie.nband) {
            case 1:
                return ("");
                break;
            case 17: // PIX
                if (especie.finalizado == 1 && especie.pix_recebido != null) {
                    return ("RECEBIDO EM " + formatarDataHora(especie.pix_recebido, 4));
                }
                else {
                    return ("AGUARDANDO PAGAMENTO");
                }
                break;
            default:
                return ("");
            // code block
        }
    };

    const adicionarObjetoNaColuna = (colunaIndex, objeto) => {
        setColunas((prevColunas) => {
            // Cria uma cópia das colunas anteriores para evitar mutação
            const novasColunas = [...prevColunas];
            // Adiciona o objeto à coluna correspondente
            novasColunas[colunaIndex] = [...novasColunas[colunaIndex], objeto];
            return novasColunas;
        });
    };

    // Função para capturar a imagem do QR Code como PNG e enviar para a API usando axios
    const handleSendToAPI = async () => {
        try {
            // Converte o QRCode gerado em uma imagem PNG usando html-to-image
            const dataUrl = await toPng(qrCodeRef.current);

            // Cria um Blob a partir do dataUrl (base64) gerado
            const blob = await fetch(dataUrl).then((res) => res.blob());

            // Cria um FormData para enviar a imagem à API
            const formData = new FormData();
            formData.append('file', blob, 'qrcode.png'); // 'file' é o nome do campo na API

            // Faz uma requisição POST para a API usando axios
            const response = await api.post('Saton/SubirQrCodeFaturado/' + props.props.fatorParcial.id_cliente + "/" + props.props.fatorParcial.id_loja_cliente + "/" + props.props.fatorParcial.ids_fator + "/" + props.props.fatorParcial.ids_loja_fator, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                console.log('Imagem enviada com sucesso!');
            } else {
                console.error('Erro ao enviar imagem:', response.statusText);
            }
        } catch (error) {
            console.error('Erro ao capturar ou enviar imagem:', error);
        }
    };

    useEffect(() => {
        if (urlQRCode != null && urlQRCode.length > 0) {
            if (qrCodeInstance.current) {
                qrCodeInstance.current.update({
                    data: urlQRCode,
                });
            }

            const qrCodeTela = new QRCodeStyling({
                width: 200,
                height: 200,
                data: urlQRCode,
                image:
                    LogoN,
                dotsOptions: {
                    color: "#000000",
                    type: "rounded"
                },
                imageOptions: {
                    crossOrigin: "anonymous",
                    margin: 5
                }
            });

            qrCodeTela.append(qrCodeRef.current);
            // qrCode.append(qrCodeRef.current);
            //  qrCode.update({
            //     data: urlQRCode
            //  });    
            // const intervalID = setInterval(myCallback, 2000, 'Parameter 1', 'Parameter 2');
            // const intervalID = setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2');
        }
    }, [urlQRCode]);


    useEffect(() => {
        if (qrCodeRef.current && qrCodeInstance.current) {
            qrCodeInstance.current.append(qrCodeRef.current);
        }
    }, [qrCodeRef]); // Executa quando `qrCodeRef` mudar

    // const downloadQRCode = () => {
    //     // Converte o QRCode gerado em um arquivo PNG
    //     if (qrCodeRef.current) {
    //       qrCode.toPng(qrCodeRef.current)
    //         .then((dataUrl) => {
    //           const link = document.createElement('a');
    //           link.download = 'qrcode.png';
    //           link.href = dataUrl;
    //           link.click();
    //         })
    //         .catch((err) => {
    //           console.error('Erro ao gerar a imagem do QRCode', err);
    //         });
    //     }
    //   };

    const montarImpressao = () => {
        _temPIXpendente = props.props.especieParcial.filter((xp) => xp.nband == 17 && xp.pix_recebido == null);
        if (processoNumero == "") {
            setProcessoNumero(props.props.fatorParcial.ids_fator + "-" + props.props.fatorParcial.ids_loja_fator);
            setProcessoData(props.props.fatorParcial.data);
        }

        // Agrupar as vendas com base no id_venda
        //props.props.especieParcial.forEach((xespec, index) => {
        //    setUrlQRCode(xespec.pix_copia_cola);
        let exibirObjetoPagamentos =
            <>
                <MuiCard variant="outlined" key={props.props.especieParcial[0].especie_id + "_" + props.props.especieParcial[0].especie_loja} paddingLeft={'0px'} margin={'0px'} textAlign={'left'} style={{ margin: '0px', padding: '0px' }}>
                    {/* { ( vendasAgrupadasLinhasPorColuna % limiteLinhasPorPagina == 0 ? <div className="page-break"></div> : <></> ) }   */}
                    <CardHeader
                        title={
                            <Box display="flex">
                                <Typography variant="h6" fontSize={'12px'}>Meios de Pagamentos</Typography>
                            </Box>
                        }
                        sx={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '-15px' }}
                    />
                    <CardContent style={{ padding: '0px', marginTop: '-10px' }}>
                        <Grid container spacing={0} sx={{ margin: '0', padding: '0', marginTop: '5px', marginLeft: '5px', paddingRight: '10px' }}>
                            <Grid item xs={12}><Divider sx={{ marginTop: '-10px' }} style={{ height: '4px', alignSelf: 'center' }} /></Grid>
                            <Grid item xs={4} fontSize={'11px'} textAlign={'left'}>Tipo</Grid>
                            <Grid item xs={5.5} fontSize={'11px'} textAlign={'left'}>Situação</Grid>
                            <Grid item xs={2.5} fontSize={'11px'} textAlign={'right'}>Total R$</Grid>
                            {
                                mostrar_meios_pagamentos(props.props.especieParcial)
                            }
                        </Grid>
                    </CardContent>
                </MuiCard>
            </>
        adicionarObjetoNaColuna(2, exibirObjetoPagamentos);
        //});
    }

    const calcularTotalVenda = (vendaId) => {
        const itensFiltrados = props.props.satonParcial.filter(
            prod => (prod.id_venda + "-" + prod.id_venda_loja) === vendaId
        );

        // Atualiza a variável itensNaPagina com o número de itens filtrados
        itensNaPagina += itensFiltrados.length;

        if (itensNaPagina > limiteLinhasPorPagina) {
            itensNaPagina = itensFiltrados.length;
        }

        // Calcula o total com base nos itens filtrados
        return itensFiltrados.reduce((total, prod) => {
            const valorItem = prod.unitario * prod.quantidade;
            // Armazena o número do item na página (poderia ser feito após o reduce também)
            // vendasAgrupadasLinhasPorColuna.push(itensNaPagina);     
            if (prod.especie === 1) {
                return total + valorItem; // Não altera o valor
            } else {
                return total + (valorItem * -1); // Multiplica por -1
            }
        }, 0); // Inicializa o total com 0
    };

    return (
        <>
            {(showModalMeuPagamentoFaturadoReciboDePagamento
                ?
                <Grid container justifyContent={"center"} spacing={2}>
                    <Grid item xs={6}>
                        <Box display="flex"
                            justifyContent="right"
                            variant={'rounded'}
                            alignItems="center"><Button bgcolor={'color'} onClick={() => setShowModalMeuPagamentoFaturadoReciboDePagamento(false)} startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box display="flex"
                            justifyContent="left"
                            variant={'rounded'}
                            alignItems="center"><Button bgcolor={'color'} onClick={handlePrint} startIcon={<Avatar src={ImpressaoIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
                    </Grid>
                </Grid>
                :
                <></>
            )}


            <div className="div to print" ref={dataToPrintRef} style={{ pageBreakInside: 'avoid' }}>

                {(showModalMeuPagamentoFaturadoReciboDePagamento
                    ?
                    <Grid container justifyContent={"center"} spacing={2} marginTop={'-10px'}>
                        <Grid item xs={3}>
                            <Box display="flex"
                                justifyContent="left"
                                variant={'rounded'}
                                marginTop={'8px'}
                                alignItems={"left"}><img src={LogoNafil} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '100px', height: 'auto', marginLeft: '8px' }} /></Box>
                        </Grid>

                        <Grid item xs={9}>
                            <Box display="flex"
                                justifyContent="left"
                                variant={'rounded'}
                                alignItems="center"><Typography>Cobrança Efetuado no Processo {processoNumero}</Typography>
                            </Box>
                            <Box display="flex"
                                justifyContent="left"
                                variant={'rounded'}
                                alignItems="right"><Typography>{"Dia: " + formatarDataHora(processoData, 4)}</Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    :
                    <></>

                )}

                <Grid container spacing={0.6} sx={{ padding: '5px', paddingLeft: '6px', paddingRight: '6px' }} >
                    {/* Coluna Central */}
                    <Grid item xs={12}>
                        {colunas[0]} {colunas[1]} {colunas[2]}
                    </Grid>
                </Grid>

                {(showModalMeuTelefone
                    ?
                    <Grid container justifyContent={"center"} spacing={2} marginTop={'0'}>
                        <Grid item xs={12}>
                            <div marginLeft="15px">
                                <Typography sx={{ fontSize: "16px", marginLeft: "15px" }}><strong>Compartilhar via WhatsApp</strong></Typography>
                                <Typography sx={{ fontSize: "12px", marginLeft: "15px" }}>Digite o Número do Telefone com WhatsApp:</Typography>
                                <Box marginLeft={"15px"}>
                                    <InputMask
                                        marginTop="5px"
                                        mask="(99) 99999-9999"
                                        value={phoneNumber}
                                        onChange={handleInputChange}
                                        placeholder="(99) 99999-9999"
                                    />
                                    <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '30px', marginLeft: '10px' }} onClick={handleEnviarWhatsAppWeb} disabled={phoneNumber.replace(/\D/g, '').length !== 11}>Enviar Mensagem</Button>
                                </Box>
                            </div>
                        </Grid>
                    </Grid>
                    :
                    <></>
                )}

                <Grid container>
                    <Grid item xs={12} sx={{ height: '10px' }}></Grid>
                </Grid>
            </div>
        </>
    );
};
export default Card;
